import React, { useRef } from "react";

export default function VoucherHeaderFields({
  voucherNo,
  onVoucherNoChange,
  referenceNo,
  onReferenceNoChange,
  voucherDate, // ISO string YYYY-MM-DD
  onVoucherDateChange,
  onOpenSettings,
  isModifyMode = false,
}) {
  const dateInputRef = useRef(null);

  // Convert YYYY-MM-DD to DD-MM-YYYY for display matching image 2 (31-08-2026)
  const displayDate = (() => {
    if (!voucherDate) return "31-08-2026";
    const parts = voucherDate.split("-");
    if (parts.length === 3) {
      const [y, m, d] = parts;
      return `${d.padStart(2, "0")}-${m.padStart(2, "0")}-${y}`;
    }
    return voucherDate;
  })();

  const handleDisplayDateChange = (val) => {
    // If user enters DD-MM-YYYY manually
    const parts = val.split("-");
    if (parts.length === 3 && parts[2].length === 4) {
      const [d, m, y] = parts;
      onVoucherDateChange(`${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`);
    }
  };

  const handleNativePickerChange = (e) => {
    onVoucherDateChange(e.target.value);
  };

  const openDatePicker = () => {
    if (dateInputRef.current) {
      if (typeof dateInputRef.current.showPicker === "function") {
        dateInputRef.current.showPicker();
      } else {
        dateInputRef.current.focus();
      }
    }
  };

  return (
    <div className="vch_header_fields_grid">
      {/* Field 1: Voucher No. * */}
      <div className="vch_field_group vch_field_voucher_no">
        <label className="vch_field_label">
          Voucher No. <span className="vch_required_star">*</span>
        </label>
        <div className="vch_input_with_addons">
          <input
            type="text"
            className="vch_form_control vch_voucher_no_input"
            value={voucherNo}
            onChange={(e) => onVoucherNoChange(e.target.value)}
            placeholder="e.g. JV-007"
          />
          <span className={`vch_auto_badge ${isModifyMode ? "vch_edit_badge" : ""}`}>
            {isModifyMode ? "(Edit)" : "(Auto)"}
          </span>
          <button
            type="button"
            className="vch_settings_btn"
            title="Configure Voucher Numbering"
            onClick={onOpenSettings}
          >
            <i className="fa-solid fa-gear"></i>
          </button>
        </div>
      </div>

      {/* Field 2: Reference No. */}
      <div className="vch_field_group vch_field_ref_no">
        <label className="vch_field_label">Reference No.</label>
        <div className="vch_input_wrapper">
          <input
            type="text"
            className="vch_form_control"
            value={referenceNo}
            onChange={(e) => onReferenceNoChange(e.target.value)}
            placeholder="e.g. REF-1023"
          />
        </div>
      </div>

      {/* Field 3: Voucher Date * */}
      <div className="vch_field_group vch_field_voucher_date">
        <label className="vch_field_label">
          Voucher Date <span className="vch_required_star">*</span>
        </label>
        <div className="vch_date_input_wrapper" onClick={openDatePicker}>
          <input
            type="text"
            className="vch_form_control vch_date_display_input"
            value={displayDate}
            onChange={(e) => handleDisplayDateChange(e.target.value)}
            placeholder="DD-MM-YYYY"
          />
          <input
            ref={dateInputRef}
            type="date"
            className="vch_native_hidden_date"
            value={voucherDate || "2026-08-31"}
            onChange={handleNativePickerChange}
            tabIndex={-1}
          />
          <span className="vch_calendar_icon" title="Choose date">
            <i className="fa-regular fa-calendar-days"></i>
          </span>
        </div>
      </div>
    </div>
  );
}
